import {safeLocalStorage} from '../../utils/safeLocalStorage.js';
import { user, getFlow, config } from '../../utils';
import { AddToCartBIModel } from '../models';
import { track } from '../../tracking/bi-track';
import {currencyToCountryISO} from '../../tracking/bi.js';

const ADD_TO_CART_STORAGE_KEY = 'add_to_cart_bi_event';
const TTL_MS = 2 * 60 * 60 * 1000; // 2 horas en milisegundos
export const addToCartBIEventListener = () => {
    const productData = JSON.parse(
        document.querySelector('[data-ec-checkout-step="2"] .js-product-data')?.innerHTML || "false"
    );
    if(!productData) {
        return;
    }

    const storageItem = safeLocalStorage.getItem(ADD_TO_CART_STORAGE_KEY);
    if (storageItem) {
        try {
            const item = JSON.parse(storageItem);
            const isExpired = (Date.now() - item.timestamp) > TTL_MS;

            if (!isExpired && item.product_id === productData.id && item.user_id === user.id) {
                return;
            }
        } catch {
        }
    }

    track(
        new AddToCartBIModel(
            user.id,
            getFlow(),
            productData.id,
            productData.owner,
            productData.price,
            config.bi_data.seller_cost,
            config.bi_data.discount,
            config.bi_data.coupon,
            currencyToCountryISO(config.bi_data.sellerCurrency)
        )
    );

    const newItem = {
        user_id: user.id,
        product_id: productData.id,
        timestamp: Date.now()
    };

    safeLocalStorage.setItem(ADD_TO_CART_STORAGE_KEY, JSON.stringify(newItem));
}
